
export default {
  name: 'icon-status-departed',
};
